import { render, staticRenderFns } from "./BuilderDashboardComponent.vue?vue&type=template&id=fea826f0"
import script from "./BuilderDashboardComponent.vue?vue&type=script&lang=js"
export * from "./BuilderDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports